export const GET_MARKETING_PROMOTION_LIST = 'GET_MARKETING_PROMOTION_LIST';
export const GET_MARKETING_PROMOTION_LIST_SUCCESS =
  'GET_MARKETING_PROMOTION_LIST_SUCCESS';
export const GET_MARKETING_PROMOTION_LIST_FAILED =
  'GET_MARKETING_PROMOTION_LIST_FAILED';

export const GET_MARKETING_PROMOTION_DETAIL = 'GET_MARKETING_PROMOTION_DETAIL';
export const GET_MARKETING_PROMOTION_DETAIL_SUCCESS =
  'GET_MARKETING_PROMOTION_DETAIL_SUCCESS';
export const GET_MARKETING_PROMOTION_DETAIL_FAILED =
  'GET_MARKETING_PROMOTION_DETAIL_FAILED';

export const CREATE_MARKETING_PROMOTION = 'CREATE_MARKETING_PROMOTION';
export const CREATE_MARKETING_PROMOTION_SUCCESS =
  'CREATE_MARKETING_PROMOTION_SUCCESS';
export const CREATE_MARKETING_PROMOTION_FAILED =
  'CREATE_MARKETING_PROMOTION_FAILED';

export const UPDATE_MARKETING_PROMOTION = 'UPDATE_MARKETING_PROMOTION';
export const UPDATE_MARKETING_PROMOTION_SUCCESS =
  'UPDATE_MARKETING_PROMOTION_SUCCESS';
export const UPDATE_MARKETING_PROMOTION_FAILED =
  'UPDATE_MARKETING_PROMOTION_FAILED';

export const DELETE_MARKETING_PROMOTION = 'DELETE_MARKETING_PROMOTION';
export const DELETE_MARKETING_PROMOTION_SUCCESS =
  'DELETE_MARKETING_PROMOTION_SUCCESS';
export const DELETE_MARKETING_PROMOTION_FAILED =
  'DELETE_MARKETING_PROMOTION_FAILED';
